import { useEffect } from "react";
import { useSite } from "@/context/SiteContext";

export const DEFAULT_TITLE = "Rəqəmsal ideyalarınızı həyata keçiririk";

export function usePageMeta(title, description) {
  const { config } = useSite();
  const home = config.contacts?.site_title || DEFAULT_TITLE;
  const suffix = config.contacts?.title_suffix || "";
  useEffect(() => {
    document.title = title ? (suffix ? `${title} — ${suffix}` : title) : home;
    if (description) document.querySelector('meta[name="description"]')?.setAttribute("content", description);
  }, [title, description, home, suffix]);
}
